import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/popups";
const defaultQuery = { orderBy: "id desc" };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};
const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const getItem = ({ id }: { id: number }) => request(`${resource}/get/${id}`, { method: "GET" });
const getUserPopups = () => request(`${resource}/getUserPopUps`, { method: "GET" });
const activate = (params: {}) => alertRequest(`${resource}/activate`, body(params));
const returnToDraft = (params: {}) => alertRequest(`${resource}/returnToDraft`, body(params));
const putToArchive = (params: {}) => alertRequest(`${resource}/putToArchive`, body(params));
const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));
const setAsReceived = (params: {}) => request(`${resource}/setAsReceived`, body(params));
const setAsViewed = (params: {}) => request(`${resource}/setAsViewed`, body(params));

export {
    apply,
    index,
    getItem,
    getUserPopups,
    restore,
    activate,
    returnToDraft,
    putToArchive,
    setAsReceived,
    setAsViewed,
};
